import odin from '@odinjs/odin';
import { FragmentCustomProvider } from './fragment-custom-provider.js';
function provideContainer(args) {
    const { dataContext, fragment, submittableFragmentContext } = args;
    const name = fragment.getName();
    getOdinBundle(name); // forces odin to create a bundle
    const provider = new FragmentCustomProvider({ dataContext, fragment, submittableFragmentContext });
    return getOdinContainer(name, provider);
}
// TODO: Odin: remove once odin fixes its build
function getOdinBundle(domain) {
    try {
        return odin.bundle(domain);
    }
    catch {
        return odin.default.bundle(domain);
    }
}
// TODO: Odin: remove once odin fixes its build
function getOdinContainer(domain, provider) {
    try {
        return odin.container(domain, provider);
    }
    catch {
        return odin.default.container(domain, provider);
    }
}
export { provideContainer, };
//# sourceMappingURL=container-provider.js.map